import React from "react";
import { EmailListBody } from "tsi-common-react/src/apps/customer-account/EmailListBody/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.EmailListDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <EmailListBody {...props} />
    </PageSkeleton>
);
